import React  from 'react'
import DropDown from '../dropdown';
import { GetCountries } from '../../../api/services/shared';

const CountriesDropDown = (props) => {
    return <DropDown api={GetCountries} search textField="Name" valueField="Id"  descriptionField="Alpha2Code" {...props} />
}

export default CountriesDropDown
